<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<h1>Prologue</h1>
<p>I suppose we all have a purpose in this world of ours. The problem is, with around eight billion other people, anything we do will always seem small to the point of being insignificant. Nevertheless, some of the actions we take can have far-reaching consequences and we cannot always predict what those consequences will be.</p>
<p>We’re only very small cogs in an extremely large machine. But every time our own cog turns, it causes those around it to turn also, each of which has the same effect on the others next to it. And the effect spreads ever outwards, like the ripples caused by a stone thrown in a pond, and has implications far beyond our knowledge or understanding.</p>
<p>Every decision we make, every action we take, can change the lives of others. A small change can lead to a different path being taken, different actions resulting from that, and so nothing is eventually as it would have been.</p>
<p>No matter how insignificant we think our lives are, things we do can have far-reaching and unpredictable consequences. And no matter how deeply we consider our actions and try to do what we think is best, there’s no guarantee that the effect will be good all the way down the line. A good deed may eventually lead to disaster; a malevolent action may ultimately have a beneficial outcome, but we have no way of knowing.</p>
<p>We just have to do what we think is best and hope it turns out alright, knowing all along that it might not do.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?130f9426